import { ApolloLink } from '@common/hooks';
import Auth from 'works/legacy/lib/auth';

export const lastRequestTimeMiddleware = new ApolloLink(
  (operation, forward) => {
    writeLastRequestTime();
    return forward(operation);
  }
);

// Async to don't wait for the result
async function writeLastRequestTime() {
  // avoid writing in local storage in every request when entity doesn't have an idle timeout
  if (!Auth.idleTimeoutDuration()) return;

  const isSignedIn = Auth.signedIn();
  const membershipId = Auth.membershipId();
  const isSessionExpired = Auth.isSessionExpired();

  if (isSignedIn && membershipId && !isSessionExpired) {
    Auth.update({ lastRequestTime: Date.now() });
  }
}
